var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'sitebuilder-element-container is-receiver' + _vm.hideControl(),style:(_vm.style()),attrs:{"element":"BoxComponent","data-hide-desktop":!this.internal_config.showDesktop,"data-hide-mobile":!this.internal_config.showMobile,"id":_vm.id}},[_c('div',{staticClass:"sitebuilder-element-receiver",style:({
     'border-radius': _vm.radius,
      background: _vm.background,
      height : _vm.height,
      width : _vm.width,
      border : _vm.border,
      'box-shadow': _vm.boxShadow,
     })},_vm._l((_vm.elements),function(element,index){return _c(element.name,{key:index,tag:"component",attrs:{"config":element.config,"id":element.id,"height_start":index,"preview":_vm.preview}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }